import { Form, Radio } from "semantic-ui-react";
import { FormError } from "../models/FormError";
import ErrorsView from "./ErrorsView";
import { DocumentRequirementKey } from "../models/globalTypes";
import { DocumentRequirementKeyList } from "../models/DocumentRequirementKey";

export interface FormData {
  id: string;
  name: string;
  key: string;
  declaration: string;
  requirementKey: DocumentRequirementKey;
}

interface Props {
  formData: FormData;
  formErrors: FormError;
  errors: string[] | undefined;
  showDocumentTypeKey: boolean;
  onChange: (formData: FormData) => void;
}

const EditDocumentTypeForm = ({ formData, formErrors, errors, showDocumentTypeKey, onChange }: Props) => {
  const handleChange = (e: any, { name, value }: any) => {
    onChange({ ...formData, [name]: value });
  };

  return (
    <>
      <Form>
        <Form.Group widths="equal">
          <Form.Field required>
            <label>Name</label>
            <Form.Input error={formErrors.name} name="name" value={formData.name} onChange={handleChange} />
          </Form.Field>
          {showDocumentTypeKey && formData.key && (
            <Form.Field disabled>
              <label>System name</label>
              <Form.Input name="systemName" value={formData.key} />
            </Form.Field>
          )}
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Field>
            <Form.Input
              label="Declaration text for when a document of this type is added to a permit (optional)"
              name="declaration"
              value={formData.declaration}
              placeholder="Declaration"
              onChange={handleChange}
              error={formErrors.declaration}
            ></Form.Input>
          </Form.Field>
        </Form.Group>
        <Form.Group grouped>
          <Form.Field required>
            <label>When is this document required?</label>
          </Form.Field>
          <Form.Field error={formErrors.requirementKey}>
            <Radio
              label={DocumentRequirementKeyList.NONE.name}
              name="requirementKey"
              value={DocumentRequirementKeyList.NONE.key}
              checked={formData.requirementKey === DocumentRequirementKeyList.NONE.key}
              onChange={handleChange}
            />
          </Form.Field>
          <Form.Field error={formErrors.requirementKey}>
            <Radio
              label={DocumentRequirementKeyList.SUBMISSION.name}
              name="requirementKey"
              value={DocumentRequirementKeyList.SUBMISSION.key}
              checked={formData.requirementKey === DocumentRequirementKeyList.SUBMISSION.key}
              onChange={handleChange}
            />
          </Form.Field>
          <Form.Field error={formErrors.requirementKey}>
            <Radio
              label={DocumentRequirementKeyList.REQUEST_AND_SUBMISSION.name}
              name="requirementKey"
              value={DocumentRequirementKeyList.REQUEST_AND_SUBMISSION.key}
              checked={formData.requirementKey === DocumentRequirementKeyList.REQUEST_AND_SUBMISSION.key}
              onChange={handleChange}
            />
          </Form.Field>
        </Form.Group>
      </Form>
      <ErrorsView errors={errors} />
    </>
  );
};

export default EditDocumentTypeForm;
